import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const DisconnetWalletIcon = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_5916_39151)">
        <path
          d="M15.8327 5.83317V2.83535C15.8327 2.26293 15.2688 1.86093 14.7277 2.04754L8.41802 4.25184M15.8327 5.83317C16.7532 5.83317 17.4993 6.57936 17.4993 7.49984V13.3332M15.8327 5.83317H9.99935M3.71417 5.89515C3.01324 6.09211 2.49935 6.73596 2.49935 7.49984V15.8332C2.49935 16.7536 3.24554 17.4998 4.16602 17.4998H15.8327C16.2929 17.4998 16.7096 17.3133 17.0112 17.0117M3.71417 5.89515C3.85786 5.85477 4.00942 5.83317 4.16602 5.83317H5.83268M3.71417 5.89515L3.52021 5.96291M3.71417 5.89515L5.33012 5.33061M1.66602 1.6665L5.33012 5.33061M5.33012 5.33061L5.83268 5.83317M5.83268 5.83317L17.0112 17.0117M17.0112 17.0117L18.3327 18.3332"
          stroke={COLORS[color]}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5916_39151">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DisconnetWalletIcon;
